import { ApiModule } from '@keenvil/littlefinger';
import ApiConfig from '../apiConfig';

/**
 * Crowd Module endpoints
 */
class CrowdModule extends ApiModule {
  /**
   * Blacklist queries
   * @param {Object} query filter object.
   *                 Contains q, page, limit, and sort.
   *                 All optionals.
   */
  queryBlacklist(query) {
    return this.adapter.query('blacklist/list', query);
  }

  findBlacklistById(id) {
    return this.adapter.find(`blacklist/${id}/info`);
  }

  updateBlacklistById(unit) {
    return this.adapter.update(`blacklist/${unit.id}`, unit);
  }

  createBlacklist(unit) {
    return this.adapter.save(`blacklist`, unit);
  }

  deleteBlacklistById(id) {
    return this.adapter.delete(`blacklist/${id}`, false);
  }

  getProviders() {
    const query = {
      all: true
    };
    return this.adapter.query(`visitors/providers`, query);
  }

  setSettings(community, settings) {
    const providers =
      settings.nullProvidersSelected || settings.curfewProvidersSelected;

    const path = `visitors/providers/time/${providers}`;
    return this.adapter.update(path, settings.providerPayloads);
  }

  findVisitorsWithCriminalRecord(query) {
    return this.adapter.query('criminalrecord', query);
  }

  updateOrCreateCriminalRecord(query) {
    return this.adapter.update(`criminalrecord`, query, false);
  }

  uploadPdf(file) {
    return this.adapter.upload(`criminalrecord/file`, file);
  }

  /**
   * Persona que ya existe con ese documento (la misma búsqueda que el alta de
   * antecedentes y de blacklist): { id, name } o 404.
   */
  findVisitorByDocument(query) {
    return this.adapter.query('visitors/document', query);
  }

  deleteCriminalRecordByVisitorId(visitorId) {
    return this.adapter.delete(`criminalrecord/${visitorId}`, false);
  }

  /*
    {
      "licensePlate": "ABC123",
      "notificationEnabled": true,
      "accessSchedule": {
        "type": "RANGE",
        "validFrom": "2024-01-01T00:00:00Z",
        "validUntil": "2024-01-05T23:59:59Z",
        "cronExpression": "* 9-16 * * *"
      },
      "invitationId": "550e8400-e29b-41d4-a716-446655440000",
      "individualId": 1234567890,
      "individualGroupId": 9876543210
    }
  */
  saveInAllowList(data) {
    return this.adapter.save(`lpr/allowlist`, data);
  }

  /*
    {
      "licensePlate": "AB123CD",
      "notificationEnabled": true,
      "actorId": "1234567890",
      "actorType": "USER",
      "actionNote": "Better car for the required load"
    }
  */
  updateInAllowList(data) {
    return this.adapter.update(`lpr/allowlist/${data.id}`, data);
  }

  getElementInAllowList(id) {
    return this.adapter.find(`lpr/allowlist/${id}`);
  }

  /*
    {
      "page": 1,
      "limit": 10,
    }
  */
  getAllInAllowList(query) {
    return this.adapter.query(`lpr/allowlist`, query);
  }

  deleteElementInAllowList(id) {
    return this.adapter.delete(`lpr/allowlist/${id}`, false);
  }

  /*
    {
      "licensePlate": "ABC123",
      "expiresAt": "2026-01-01T00:00:00Z",
      "actorId": "550e8400-e29b-41d4-a716-446655440000",
      "actorType": "USER",
      "reason": "Ongoing criminal investigation"
    }
  */
  saveInBlockList(data) {
    return this.adapter.save(`lpr/blocklist`, data);
  }

  getElementInBlockList(id) {
    return this.adapter.find(`lpr/blocklist/${id}`);
  }

  /*
    {
      "page": 1,
      "limit": 10,
    }
  */
  getAllInBlockList(query) {
    return this.adapter.query(`lpr/blocklist`, query);
  }

  deleteElementInBlockList(id) {
    return this.adapter.delete(`lpr/blocklist/${id}`, false);
  }
}

export default new CrowdModule('crowd', ApiConfig);
